
import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText } from '@wordpress/block-editor';
import './editor.scss';

export default function Edit(props) {

	const blockProps = useBlockProps({
		className: 'c4l-quote'
	});

	const { attributes, setAttributes } = props;
	const { text, caption } = attributes;

	return (
		<div {...blockProps}>
			<div className='c4l-quote-content'>
				<RichText
					tagName='div'
					className='c4l-quote-text'
					multiline='p'
					value={text}
					onChange={(newVal) => setAttributes({ text: newVal })}
					placeholder={__("Type the quote here.", 'quote')}
				/>
				<RichText
					tagName='div'
					className='c4l-quote-caption'
					multiline='p'
					value={caption}
					onChange={(newVal) => setAttributes({ caption: newVal })}
					placeholder={__("AUTHOR NAME, Work Title", 'quote')}
				/>
			</div>
		</div>
	);
}
